import React from 'react';
import './Header.css';
import logo from '../assets/images/erubright-icon.png';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <div className="hero">
      <div className="hero-brand">
        <img src={logo} alt="EruBright logo" className="hero-logo" />

        <h1 className="hero-title">
          <span className="eru">Eru</span>
          <span className="bright">Bright</span>
        </h1>
      </div>

      <p className="hero-tagline">
        Advancing battery research and development
      </p>

      <Link to="/contact" className="hero-button">
        Contact us
      </Link>
    </div>
  );
}

export default Header;